import { render, staticRenderFns } from "./CustomQuestionAnswerText.vue?vue&type=template&id=2952af2d"
import script from "./CustomQuestionAnswerText.vue?vue&type=script&lang=js"
export * from "./CustomQuestionAnswerText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports